
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/dashboard",
      function () {
        return require("private-next-pages/account/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/dashboard"])
      });
    }
  